interface ModelTypeFilterProps {
  selectedType: string | null;
  types: string[];
  onTypeChange: (type: string | null) => void;
}

export const ModelTypeFilter = ({
  selectedType,
  types,
  onTypeChange,
}: ModelTypeFilterProps) => {
  if (types.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onTypeChange(null)}
          className={`px-4 py-2 text-sm rounded-full transition-all ${
            selectedType === null
              ? "bg-foreground text-background"
              : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
          }`}
          type="button"
        >
          Tots
        </button>
        {types.map((type) => (
          <button
            key={type}
            onClick={() => onTypeChange(type)}
            className={`px-4 py-2 text-sm rounded-full transition-all ${
              selectedType === type
                ? "bg-foreground text-background"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
            }`}
            type="button"
          >
            {type}
          </button>
        ))}
      </div>
    </div>
  );
};

